import { render, staticRenderFns } from "./addshopCategory.vue?vue&type=template&id=7f4cb81e&scoped=true"
import script from "./addshopCategory.vue?vue&type=script&lang=js"
export * from "./addshopCategory.vue?vue&type=script&lang=js"
import style0 from "./addshopCategory.vue?vue&type=style&index=0&id=7f4cb81e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cb81e",
  null
  
)

export default component.exports